import { BorderGridContainer, GridBox, Section } from '@ahmdigital/ui';
import { isEmpty, isNil } from 'lodash/fp';

import constants from '../../../ahm-constants';
import ImageHeader from './components/image-header';
import isPartnerOffer from '../utils/is-partner-offer';
import RedirectApapter from '../../../utils/redirect-adapter';
import styles from './styles.module.sass';
import Support from '../components/support';
import TermsAndConditions from '../../../components/offers/terms-and-conditions';
import useGetAllPlaceholders from '../../../components/offers/logic/use-get-all-placeholders';
import useGetOfferTerms from '../../../components/offers/logic/use-get-offer-terms';

type OfferTermsAndConditionsPageProps = {
  match: {
    params: {
      offerId: string;
    };
  };
};

const OfferTermsAndConditionsPage = ({ match }: OfferTermsAndConditionsPageProps) => {
  const offerId = match?.params?.offerId;

  const { loading: isLoadingOffer, offer } = useGetOfferTerms(offerId);
  const { loading: isLoadingPlaceholders, placeholders } = useGetAllPlaceholders();

  const isAllDataReady = !isEmpty(offer) && !isEmpty(placeholders);
  const isLoading = isLoadingOffer || isLoadingPlaceholders;

  if (isLoading && !isAllDataReady) {
    return null;
  }

  if (isNil(offer) || isPartnerOffer(offer)) {
    return <RedirectApapter to={constants.URLS.SALES.ERROR_404} />;
  }

  return (
    <>
      <BorderGridContainer hideBorderTop>
        <GridBox padding="1rem">
          <Section variant={[styles.section, 'paddingBottomSpacerNone', 'paddingTopSpacer2']} id="terms">
            <ImageHeader offer={offer} placeholders={placeholders} />
            <div className={styles.termsContainer}>
              <TermsAndConditions offer={offer} placeholders={placeholders} />
            </div>
          </Section>
        </GridBox>
      </BorderGridContainer>
      <Support />
    </>
  );
};

export default OfferTermsAndConditionsPage;
export { OfferTermsAndConditionsPage as OfferTermsAndConditionsPageForTest };
